import styled from 'styled-components';

import { Box } from '@/components/Box';
import { LegacyButton } from '@/components/LegacyButton';
import { theme } from '@/theme';

export const DiscoverButton = styled(LegacyButton)`
  width: 294px;
  height: 48px;
  margin-top: 32px;
  margin-bottom: 40px;
  ${theme.media.md.up} {
    max-width: 373px;
  }
`;
export const FlexButtonBox = styled(Box)`
  display: flex;
  justify-content: center;
`;
